export function formatBoolean(value) {
    return value ? 'True' : 'False';
}